import { render, staticRenderFns } from "./todayPage.vue?vue&type=template&id=6b589108&scoped=true&"
import script from "./todayPage.vue?vue&type=script&lang=ts&"
export * from "./todayPage.vue?vue&type=script&lang=ts&"
import style0 from "./todayPage.vue?vue&type=style&index=0&id=6b589108&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b589108",
  null
  
)

export default component.exports